import { SERVICE_NOW_COLUMN_ID } from "../constants";
import ServiceNowTableDescriptionCell from "./DescriptionCell";
import ServiceNowTableDropdownCell from "./DropdownCell";
import ServiceNowTableNameCell from "./NameCell";
import ServiceNowTableSpaceCell from "./SpaceCell";

export const SERVICE_NOW_TABLE_CELLS = {
  [SERVICE_NOW_COLUMN_ID.NAME]: ServiceNowTableNameCell,
  [SERVICE_NOW_COLUMN_ID.SPACE]: ServiceNowTableSpaceCell,
  [SERVICE_NOW_COLUMN_ID.DESCRIPTION]: ServiceNowTableDescriptionCell,
  [SERVICE_NOW_COLUMN_ID.DROPDOWN]: ServiceNowTableDropdownCell,
};
